import type { SecondaryMarketBlotterFetchCsvApi } from 'apiConnector/secondary-market-blotter';
import { ConnectedFilter } from 'components/Blotters/SecondaryMarketTrade/filter/Filter';
import { FC, useCallback } from 'react';
import { map } from 'rxjs/operators';
import type { ITradeRequest } from 'state/blotters/secondaryMarketTradeBlotter/secondaryMarketTradeBlotter.selector';
import { downloadCsv } from 'utils/documents/downloadDocument';

import { logAnalytics } from '../../../../shared/middlewares/analytics/logger';

interface ComponentProps {
  fetchCsvApi: SecondaryMarketBlotterFetchCsvApi;
}

const Component: FC<ComponentProps> = ({ fetchCsvApi: { fetchCSV } }) => {
  const fetch = useCallback(
    (request: ITradeRequest) => {
      return fetchCSV(request).pipe(
        map(file => {
          logAnalytics.trackEvent('Blotter Secondary Market trades', 'Download CSV');
          downloadCsv(file, 'secondary_blotter');
        }),
      );
    },
    [fetchCSV],
  );

  return <ConnectedFilter fetchCsv={fetch} />;
};

export default Component;
